import { useRMSelector } from 'redux/hooks';

export const useIngredientInfo = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current.info);
};

export const useIngredientTypes = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current.types);
};

export const useIngredientAliases = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current.aliases);
};

export const useIngredientCASNumbers = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current.casNumbers);
};

export const useIngredientMergeAndDeletedStockIds = () => {
  return useRMSelector((state) => state?.ingredientDetail?.mergedAndDeletedStockIds);
};

export const useIngredientStocks = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current.stocks);
};

export const useSelectedStockRows = () => {
  return useRMSelector((state) => state?.ingredientDetail?.selectedStockRows);
};

export const useHasBufferType = (): boolean => {
  return useRMSelector((state) =>
    state?.ingredientDetail?.current.types?.find((t) => t.isBuffer) ? true : false,
  );
};

export const useSelectedIngredientRows = () => {
  return useRMSelector((state) => state?.ingredientsTable?.selectedRows);
};

export const useIngredientBufferDataPoints = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current.bufferDataPoint);
};

export const useIngredientLoadingState = () => {
  return useRMSelector((state) => state?.ingredientDetail?.loading);
};

export const useErrorVisibility = () => {
  return useRMSelector((state) => state?.ingredientDetail?.errorVisiblity);
};

export const useStocksErrors = () => {
  return useRMSelector((state) => state?.ingredientDetail?.stockErrors);
};

export const useCurrentIngredientDetails = () => {
  return useRMSelector((state) => state?.ingredientDetail?.current);
};

export const useOriginalIngredientDetails = () => {
  return useRMSelector((state) => state?.ingredientDetail?.original);
};

export const useIngredientDeletedData = () => {
  return useRMSelector((state) => state?.ingredientDetail?.deleted);
};

export const useIsDirty = () => {
  return useRMSelector((state) => state?.ingredientDetail?.isDirty);
};

export const useHasNonBufferType = (): boolean => {
  return useRMSelector((state) =>
    state?.ingredientDetail?.current.types?.find((t) => !t.isBuffer) ? true : false,
  );
};

export const useAliasErrors = () => {
  return useRMSelector((state) => state?.ingredientDetail?.aliasErrors);
};

export const usecasNumberErrors = () => {
  return useRMSelector((state) => state?.ingredientDetail?.casNumberErrors);
};

export const useBufferDataPointErrors = () => {
  return useRMSelector((state) => state?.ingredientDetail?.bufferDataErrors);
};
